import script from "./AdminRecordingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRecordingDetail.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AdminRecordingDetail.vue?vue&type=style&index=1&id=e6f41200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6f41200"]])

export default __exports__